import { Api } from '@/services/Api'

export default {

  fetchInverterStatus(plantList) {
    return Api().post(
      '/api/v2/inverter-status/status',
      { plantList }
    )
  },

  fetchPlantTree(plantList) {
    return Api().post(
      '/api/v2/inverter-status/plantTree',
      { plantList }
    )
  }

}